import type { Response } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface LevelItem {
  id: number
  name: string
  description?: string | null
  min_point: number
  image_path?: string | null
  image_url?: string | null
  created_at: string
  updated_at: string
}

export interface LevelFormValues {
  name: string
  min_point: number
  description?: string
}

export const levelService = {
  list() {
    return HttpRequest.get("v1/levels").json<Response<LevelItem[]>>()
  },

  create(formData: FormData) {
    return HttpRequest.post("v1/levels", {
      body: formData,
    }).json<Response<LevelItem>>()
  },

  update(id: number, formData: FormData) {
    return HttpRequest.put(`v1/levels/${id}`, {
      body: formData,
    }).json<Response<LevelItem>>()
  },
}
